import { render, staticRenderFns } from "./RecipeItemDetail.vue?vue&type=template&id=dca67b8c&"
import script from "./RecipeItemDetail.vue?vue&type=script&lang=js&"
export * from "./RecipeItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports